/* eslint-disable*/
import stackingChart from "./stackingChart";
import columnarChart from "./columnarChart";
import ueditor from './ueditor';
import newTag from './newTag';
import cityPicker from './cityPicker';
export default {
  install(Vue) {
    Vue.component('stackingChart', stackingChart);
    Vue.component('columnarChart', columnarChart);
    Vue.component('newTag', newTag);
    Vue.component('ueditor', ueditor);
    Vue.component('cityPicker', cityPicker);
  }
}



// WEBPACK FOOTER //
// ./src/common/component/index.js